'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const modal_types = require('./modal.types.js');

var ModalContainer = styled__default.div.withConfig({
  displayName: "modalstyle__ModalContainer",
  componentId: "sc-13nyj6y-0"
})(["bottom:0;left:0;right:0;top:0;position:fixed;z-index:999999;&:focus{outline:none;}", " ", ""], function (_ref) {
  var isCentered = _ref.isCentered,
    scrollType = _ref.scrollType;
  if (isCentered) {
    var alignItems = scrollType === modal_types.ScrollType.CONTAINER ? 'flex-start' : 'center';
    return "\n        align-items: ".concat(alignItems, ";\n        display: flex;\n        justify-content: center;\n      ");
  }
  return;
}, function (_ref2) {
  var scrollType = _ref2.scrollType;
  return scrollType === modal_types.ScrollType.CONTAINER && 'overflow: auto;';
});

exports.ModalContainer = ModalContainer;
